export const MERCHANT_CAPABILITIES = ['supports3DS', 'supportsCredit', 'supportsDebit'];

export const SUPPORTED_NETWORKS = ['amex', 'discover', 'masterCard', 'visa'];

export const SUPPORTED_METHODS = 'https://apple.com/apple-pay';

export const APPLE_PAY = 'applepay';